import * as RadixPopover from '@radix-ui/react-popover'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

type GasSettingsNetworkStatusProps = {
  congestion: number | undefined
}

export const GasSettingsNetworkCongestion: React.FC<
  GasSettingsNetworkStatusProps
> = ({ congestion }) => {
  const { t } = useTranslation()

  const congestionLabel = (() => {
    if (congestion === undefined) {
      return undefined
    }
    if (congestion < 0.33) {
      return t('gas-settings.congestion.low')
    }
    if (congestion < 0.66) {
      return t('gas-settings.congestion.stable')
    }
    return t('gas-settings.congestion.high')
  })()

  const renderThumb = () => {
    if (congestion === undefined) {
      return undefined
    }

    return (
      <RadixPopover.Root open={true}>
        <RadixPopover.Trigger asChild>
          <StatusThumb style={{ left: `${congestion * 100}%` }} />
        </RadixPopover.Trigger>

        <RadixPopover.Content
          side="bottom"
          align="center"
          sideOffset={8}
          collisionPadding={{ left: 12, right: 12 }}
        >
          <StatusLabel>{congestionLabel}</StatusLabel>
        </RadixPopover.Content>
      </RadixPopover.Root>
    )
  }

  return (
    <StatusBar>
      <StatusBarTrack />
      {renderThumb()}
    </StatusBar>
  )
}

const StatusBar = styled.div`
  padding-top: 4px;
  height: 38px;
  position: relative;
`

const StatusBarTrack = styled.div`
  border-radius: 8px;
  height: 6px;
  background: linear-gradient(90deg, #00d085 0%, #b57135 49%, #ff113c 100%);
`

const StatusThumb = styled.div`
  position: absolute;
  right: 0px;
  top: 0;
  transform: translateX(-50%);

  width: 14px;
  height: 14px;

  border-radius: 50%;
  background: var(--background-12);
`

const StatusLabel = styled.div`
  color: var(--text-12);
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
`
